


class ProfileListData {
    constructor(userId,userNum, name,gender, age, height, qualification,educationCategory,occupation, caste, religion, city, state, country, isPaidUser, is_Shortlist,isShortListed,
        profilePath, type,email_Status, mobileNumber_Status, documentStatus, documentPath, is_Interestlist, line_1, line_2,
    salary,isPaid,lookUpId,is_ChatRequest,requestType,isBlurred,isPaidForAstrology,living_Preference_Id,living_Preference,themeColour,themeColourText,themeColourNumber) 
        {
        this.userId = userId;
        this.userNum = userNum;
        this.name = name;
        this.gender = gender;
        this.age = age;
        this.height = height;
        this.qualification = qualification;
        this.educationCategory = educationCategory;
        this.occupation = occupation;
        this.religion = religion;
        this.city = city;
        this.state = state;
        this.caste = caste;
        this.country = country;
        this.isPaidUser = isPaidUser;
        this.is_Shortlist = is_Shortlist;
        this.isShortListed=isShortListed;
        this.profilePath = profilePath;

        this.type = type;
        this.email_Status = email_Status;
        // this.email_Status =eMail_Status;
        this.mobileNumber_Status = mobileNumber_Status;
        this.documentStatus = documentStatus;
        this.documentPath = documentPath;
        this.is_Interestlist = is_Interestlist;
        this.line_1 = line_1;
        this.line_2 = line_2;
        this.salary = salary;
        this.isPaid = isPaid;
        this.lookUpId = lookUpId;
        this.is_ChatRequest = is_ChatRequest;
        this.requestType  = requestType ;
        this.isBlurred = isBlurred;
        this.isPaidForAstrology = isPaidForAstrology;
         this.living_Preference_Id = living_Preference_Id;
        this.living_Preference = living_Preference;
        this.themeColour = themeColour;
        this.themeColourText = themeColourText;
        this.themeColourNumber = themeColourNumber;



    }
    static fromJson(json) {
        return new ProfileListData(
            json.userId,
            json.userNum,
            json.name,
            json.gender,
            json.age,
            json.height,
            json.qualification,
            json.educationCategory,
            json.occupation,
            json.caste,
            json.religion,
            json.city,
            json.state,
            json.country,
            json.isPaidUser,
            json.is_Shortlist,
            json.isShortListed,
            json.profilePath,

            json.type,
            // json.email_Status,
            json.email_Status,
            json.mobileNumber_Status,
            json.documentStatus,
            json.documentPath,
            json.is_Interestlist,
            json.line_1,
            json.line_2,
            json.salary,
            json.isPaid,
            json.lookUpId,
            json.is_ChatRequestlist,
            json.requestType ,
            json.isBlurred,
            json.isPaidForAstrology,
            json.living_Preference_Id,
            json.living_Preference,
            json.themeColour,
            json.themeColourText,
            json.themeColourNumber

        );
    }
}
export default ProfileListData;